<!-- 个人信息 -->
<template>
	<div class="bindnew">
        <van-form >
        <van-field
            v-model="phone"
            label="新手机号码"
            placeholder="请输入新的手机号"
        />
        <van-field
            v-model="sms"
            label="短信验证"
            placeholder="请输入验证码"
             :border="false"
            use-button-slot
        >
        <van-button slot="button"  size="small" type="primary"
                        @click="sendCode" plain color="#d2020d">{{sendTimeText}}</van-button>
        </van-field>
    <div style="margin: 30px;">
        <van-button round block type="info" native-type="submit" color="#d2020d" @click="onSubmit">提交</van-button>
    </div>
</van-form>
		
	</div>
</template>
<script>
	import {SendCode,BindMobile,PersoanalUserInfo} from '../../../config/interface.js'
    let codeTimer;
	export default{
		data(){
			return{
				userInfo:'',
                showKeyboard:false,
                phone:'',
                sms:'',
                isClick: true,
                sendTimeText:'获取验证码',
                countdown:60,
				isReSend:true     //能否再次点击发送验证码
			}
		},
        created()
        {
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){

                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		mounted(){
			// console.log(111)
		},
		methods:{
			//得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
            // 发送验证码
			getCode(){
                this.sendTime();
				const url=SendCode;
				let params={
                    mobile:this.phone,
                };
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						common.toast(res.data.code,1000,'success',()=>{
						})
					}
                    else{
                        common.toast(res && res.error_msg?res.error_msg: "未知错误",1000,'fail',()=>{
										})

                    }
				})
			},
            //点击发送验证码
			sendCode(){
				if(this.isReSend&&this.verifyMobile()){
					this.getCode();
					this.isReSend=false;
				}
			},
            //验证手机号
			verifyMobile(){
				let mobile=this.phone;
				if(mobile==''){
					common.toast('请输入手机号',1000)
				}else if(!(/^1[3456789]\d{9}$/.test(mobile))){
					common.toast('请输入正确手机号',1000)
				}else{
					return true;
				}
				return false;
			},
            sendTime(){
					codeTimer=setTimeout(()=>{
						if(this.countdown==1){
							this.clearCodeTimer();
							return;							
						}else{
							this.countdown--;
							this.sendTimeText='重新发送('+this.countdown+'s)';
							setTimeout(this.sendTime(), 1000);
						}
				  	}, 1000)
			},
			//清除定时器
			clearCodeTimer(){
				clearTimeout(codeTimer);
				this.isReSend=true;
				this.sendTimeText="获取验证码";
				this.countdown=60;
			},
            onSubmit(){
                const url=BindMobile;
				let params={
                    mobile: this.phone,
                    msgcode: this.sms,
                };
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						common.toast('修改成功',1000,'success',()=>{
                            this.$router.push({
                                path:'/vascularNews/personal'
                            })
						})
					}
                    else{
                        common.toast(res && res.error_msg?res.error_msg: "未知错误",1000,'fail',()=>{
										})
                    }
				})

            }
		}
	}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/VascularSystem/User/BindNew.vue